export const experienciasComplementares = [
  {
    id: 'diario-eu-futuro',
    categoria: 'Experiência Complementar',
    titulo: 'Diário do Eu do Futuro',
    subtitulo: 'Caderno físico premium para registrar sua jornada de transformação',
    preco: 147,
    descricao: 'O Diário do Eu do Futuro é muito mais que um caderno: é uma ferramenta de transformação pessoal cuidadosamente desenvolvida para guiar você em sua jornada de autoconhecimento. Com páginas estruturadas, exercícios exclusivos e design sofisticado, este diário físico premium se torna seu companheiro diário na construção da vida que você deseja viver. Cada página foi pensada para facilitar a reflexão profunda, o registro de insights e o acompanhamento da sua evolução ao longo do tempo.',
    descricaoDetalhada: 'Desenvolvido por especialistas em desenvolvimento pessoal e design de experiências, o Diário do Eu do Futuro combina metodologias comprovadas de journaling terapêutico com exercícios práticos de visualização criativa. O material premium inclui papel de alta gramatura, capa dura com acabamento especial e marcador de páginas em tecido. São 240 páginas estruturadas em seções temáticas que guiam você através de diferentes aspectos da sua transformação: identidade futura, valores essenciais, metas de longo prazo, gratidão diária, reflexões semanais e celebração de conquistas.',
    imagemHero: 'https://public.readdy.ai/ai/img_res/de844f7d2fa877e046b4ea09caf6534b.jpg',
    beneficios: [
      {
        icone: 'ri-book-open-line',
        titulo: 'Estrutura Guiada',
        descricao: 'Páginas organizadas com exercícios e prompts que facilitam a reflexão profunda e o autoconhecimento'
      },
      {
        icone: 'ri-star-line',
        titulo: 'Material Premium',
        descricao: 'Capa dura com acabamento especial, papel de alta gramatura e marcador de páginas em tecido'
      },
      {
        icone: 'ri-calendar-check-line',
        titulo: 'Acompanhamento Diário',
        descricao: 'Seções para registro diário de gratidão, insights e progresso em direção aos seus objetivos'
      },
      {
        icone: 'ri-lightbulb-line',
        titulo: 'Exercícios Exclusivos',
        descricao: 'Atividades práticas de visualização criativa e planejamento estratégico da sua vida futura'
      },
      {
        icone: 'ri-trophy-line',
        titulo: 'Celebração de Conquistas',
        descricao: 'Espaços dedicados para reconhecer e celebrar cada passo da sua jornada de transformação'
      },
      {
        icone: 'ri-heart-line',
        titulo: 'Design Inspirador',
        descricao: 'Layout elegante e sofisticado que torna o momento de escrever ainda mais especial e significativo'
      }
    ],
    oQueVaiReceber: [
      'Diário físico premium com 240 páginas de alta gramatura',
      'Capa dura com acabamento especial e detalhes em dourado',
      'Marcador de páginas em tecido para facilitar o uso diário',
      'Guia completo de como usar o diário para máxima transformação',
      '52 exercícios semanais de reflexão e planejamento estratégico',
      'Seções temáticas: Identidade Futura, Valores, Metas, Gratidão',
      'Páginas para registro diário com prompts inspiradores',
      'Espaços para celebração mensal de conquistas e aprendizados',
      'Exercícios de visualização criativa e reprogramação mental',
      'Acesso ao grupo exclusivo de usuários do Diário no Telegram',
      'Vídeos tutoriais sobre técnicas avançadas de journaling',
      'Entrega em embalagem premium com carta de boas-vindas'
    ],
    meditacaoRecomendada: {
      titulo: 'Meditação: Conexão com o Eu do Futuro',
      descricao: 'Pratique esta meditação antes de escrever no seu diário para acessar insights mais profundos',
      link: 'https://www.youtube.com/watch?v=exemplo-meditacao-diario'
    },
    experienciasRelacionadas: ['audios-premium', 'kit-fisico-premium']
  },
  {
    id: 'audios-premium',
    categoria: 'Experiência Complementar',
    titulo: 'Áudios Premium de Reprogramação',
    subtitulo: 'Coleção exclusiva de 15 áudios para transformação profunda',
    preco: 197,
    descricao: 'Uma biblioteca completa de áudios terapêuticos desenvolvidos por especialistas em neurociência e desenvolvimento humano. Esta coleção exclusiva combina técnicas avançadas de hipnose ericksoniana, PNL, visualização criativa e frequências binaurais para facilitar mudanças profundas em nível subconsciente. Cada áudio foi cuidadosamente produzido com qualidade de estúdio, narração profissional e trilha sonora original para criar uma experiência imersiva de transformação.',
    descricaoDetalhada: 'Os Áudios Premium de Reprogramação representam o que há de mais avançado em tecnologia de transformação pessoal através do som. Desenvolvidos ao longo de 3 anos por uma equipe multidisciplinar de psicólogos, neurocientistas e produtores musicais, cada áudio utiliza múltiplas camadas de técnicas terapêuticas: sugestões hipnóticas cuidadosamente elaboradas, frequências binaurais específicas para cada objetivo, música terapêutica em 432Hz e efeitos sonoros ASMR para relaxamento profundo. A coleção completa abrange 15 temas essenciais para transformação integral: autoestima, prosperidade, relacionamentos, saúde, propósito, criatividade, foco, sono reparador, liberação de traumas, perdão, gratidão, confiança, coragem, abundância e realização pessoal.',
    imagemHero: 'https://readdy.ai/api/search-image?query=premium%20headphones%20with%20golden%20accents%20on%20elegant%20dark%20surface%20with%20soft%20ambient%20lighting%20meditation%20wellness%20concept%20luxury%20audio%20experience%20high%20quality%20photography&width=1200&height=600&seq=audios-hero-001&orientation=landscape',
    beneficios: [
      {
        icone: 'ri-headphone-line',
        titulo: 'Qualidade de Estúdio',
        descricao: 'Áudios produzidos profissionalmente com narração clara e trilha sonora original em 432Hz'
      },
      {
        icone: 'ri-brain-line',
        titulo: 'Reprogramação Profunda',
        descricao: 'Técnicas avançadas de hipnose, PNL e frequências binaurais para mudanças em nível subconsciente'
      },
      {
        icone: 'ri-time-line',
        titulo: 'Flexibilidade Total',
        descricao: 'Ouça quando e onde quiser, com áudios de 15 a 45 minutos para diferentes momentos do dia'
      },
      {
        icone: 'ri-download-cloud-line',
        titulo: 'Acesso Vitalício',
        descricao: 'Download ilimitado de todos os áudios em alta qualidade para usar offline sempre que precisar'
      },
      {
        icone: 'ri-list-check-line',
        titulo: '15 Temas Essenciais',
        descricao: 'Coleção completa cobrindo autoestima, prosperidade, relacionamentos, saúde, propósito e mais'
      },
      {
        icone: 'ri-refresh-line',
        titulo: 'Atualizações Gratuitas',
        descricao: 'Receba novos áudios e versões atualizadas sem custo adicional ao longo do tempo'
      }
    ],
    oQueVaiReceber: [
      '15 áudios premium de reprogramação mental (duração total: 6h30min)',
      'Áudio 1: Autoestima Inabalável (25 min)',
      'Áudio 2: Prosperidade e Abundância (30 min)',
      'Áudio 3: Relacionamentos Saudáveis (28 min)',
      'Áudio 4: Saúde Vibrante (22 min)',
      'Áudio 5: Propósito de Vida (35 min)',
      'Áudio 6: Criatividade Ilimitada (20 min)',
      'Áudio 7: Foco e Produtividade (18 min)',
      'Áudio 8: Sono Reparador (45 min)',
      'Áudio 9: Liberação de Traumas (32 min)',
      'Áudio 10: Perdão e Paz Interior (27 min)',
      'Áudio 11: Gratidão Profunda (15 min)',
      'Áudio 12: Confiança Absoluta (24 min)',
      'Áudio 13: Coragem para Agir (21 min)',
      'Áudio 14: Mentalidade de Abundância (29 min)',
      'Áudio 15: Realização Pessoal (26 min)',
      'Guia completo de uso com protocolo de 90 dias',
      'Planilha de acompanhamento de progresso',
      'Acesso vitalício com download ilimitado em MP3 320kbps',
      'Versões alternativas com e sem música de fundo',
      'Atualizações gratuitas de novos áudios lançados',
      'Suporte prioritário via WhatsApp para dúvidas'
    ],
    meditacaoRecomendada: {
      titulo: 'Meditação: Preparação para Reprogramação',
      descricao: 'Use esta meditação antes dos áudios para entrar em estado receptivo ideal',
      link: 'https://www.youtube.com/watch?v=exemplo-meditacao-audios'
    },
    experienciasRelacionadas: ['diario-eu-futuro', 'kit-fisico-premium']
  },
  {
    id: 'kit-fisico-premium',
    categoria: 'Experiência Complementar',
    titulo: 'Kit Físico Premium',
    subtitulo: 'Conjunto completo de ferramentas para sua transformação',
    preco: 397,
    descricao: 'O Kit Físico Premium é a experiência mais completa e imersiva que oferecemos. Este conjunto exclusivo reúne todos os recursos físicos e digitais necessários para uma jornada profunda de autoconhecimento e transformação. Desenvolvido para quem busca excelência e está comprometido com resultados extraordinários, o kit combina materiais de altíssima qualidade com conteúdos exclusivos que não estão disponíveis em nenhum outro lugar. É o investimento definitivo na construção do seu futuro ideal.',
    descricaoDetalhada: 'O Kit Físico Premium representa o ápice da nossa metodologia de transformação pessoal. Cada item foi cuidadosamente selecionado e desenvolvido para criar uma experiência multissensorial que facilita mudanças profundas e duradouras. O kit inclui o Diário do Eu do Futuro em versão especial com capa em couro sintético premium, a coleção completa de Áudios Premium em pen drive personalizado, um conjunto de 52 cartas de reflexão semanal com acabamento especial, um pôster motivacional de parede em papel fotográfico de alta qualidade, marcadores de página exclusivos, adesivos inspiradores, um guia impresso de 120 páginas com exercícios avançados, acesso vitalício à plataforma digital com conteúdos exclusivos, e participação em 4 encontros virtuais ao vivo por ano com a criadora do método. Tudo acondicionado em uma caixa premium com acabamento sofisticado.',
    imagemHero: 'https://readdy.ai/api/search-image?query=luxury%20premium%20gift%20box%20set%20with%20elegant%20items%20journal%20cards%20and%20golden%20details%20on%20sophisticated%20dark%20background%20high%20end%20product%20photography%20minimalist%20aesthetic&width=1200&height=600&seq=kit-hero-001&orientation=landscape',
    beneficios: [
      {
        icone: 'ri-gift-line',
        titulo: 'Experiência Completa',
        descricao: 'Todos os recursos físicos e digitais reunidos em um único kit premium de transformação'
      },
      {
        icone: 'ri-vip-crown-line',
        titulo: 'Materiais Exclusivos',
        descricao: 'Itens de altíssima qualidade com acabamentos especiais disponíveis apenas neste kit'
      },
      {
        icone: 'ri-group-line',
        titulo: 'Encontros ao Vivo',
        descricao: 'Participe de 4 encontros virtuais exclusivos por ano com a criadora do método'
      },
      {
        icone: 'ri-infinity-line',
        titulo: 'Acesso Vitalício',
        descricao: 'Plataforma digital completa com conteúdos exclusivos e atualizações constantes'
      },
      {
        icone: 'ri-medal-line',
        titulo: 'Certificado Premium',
        descricao: 'Certificado digital de membro premium com benefícios e descontos exclusivos'
      },
      {
        icone: 'ri-customer-service-line',
        titulo: 'Suporte VIP',
        descricao: 'Atendimento prioritário via WhatsApp com resposta em até 2 horas úteis'
      }
    ],
    oQueVaiReceber: [
      'Diário do Eu do Futuro - Edição Premium com capa em couro sintético',
      'Pen drive personalizado com 15 Áudios Premium de Reprogramação',
      'Conjunto de 52 Cartas de Reflexão Semanal com acabamento especial',
      'Pôster motivacional de parede (60x90cm) em papel fotográfico',
      'Kit com 5 marcadores de página exclusivos em metal dourado',
      'Cartela com 50 adesivos inspiradores para decoração',
      'Guia impresso de 120 páginas com exercícios avançados',
      'Acesso vitalício à plataforma digital com área exclusiva',
      'Participação em 4 encontros virtuais ao vivo por ano',
      'Certificado digital de Membro Premium',
      'Desconto de 30% em todos os exercícios avulsos',
      'Desconto de 20% na renovação de planos anuais',
      'Acesso antecipado a novos lançamentos e conteúdos',
      'Grupo VIP no Telegram com networking exclusivo',
      'Suporte prioritário via WhatsApp (resposta em até 2h úteis)',
      'Bônus: Masterclass gravada "Os 7 Pilares da Transformação" (2h)',
      'Bônus: E-book "Rituais Matinais de Alta Performance" (80 páginas)',
      'Entrega em caixa premium com acabamento sofisticado',
      'Carta de boas-vindas personalizada assinada',
      'Garantia estendida de 60 dias de satisfação total'
    ],
    meditacaoRecomendada: {
      titulo: 'Meditação: Cerimônia de Compromisso',
      descricao: 'Pratique esta meditação especial ao receber seu kit para selar seu compromisso com a transformação',
      link: 'https://www.youtube.com/watch?v=exemplo-meditacao-kit'
    },
    experienciasRelacionadas: ['diario-eu-futuro', 'audios-premium']
  }
];